// Unregisters every service worker and clears all Cache Storage entries, so
// the next load is guaranteed to fetch a fresh copy of everything (bundle,
// index.html, headers) from the server instead of whatever was cached.
//
// Deliberately does NOT reload the page or show any toast itself — the two
// callers (the manual "Clear app cache" menu item in MainLayout.jsx, and the
// automatic version-mismatch handling in src/axios/index.js's response
// interceptor) each want different messaging and timing around the reload,
// so they wrap this shared core with their own.
export const clearAppCache = async () => {
  if ("serviceWorker" in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((r) => r.unregister()));
  }
  if ("caches" in window) {
    const keys = await caches.keys();
    await Promise.all(keys.map((k) => caches.delete(k)));
  }
};
